import Quill from 'quill'
import LinkFormat from 'quill/formats/link'

const Link = Quill.import('formats/link') as typeof LinkFormat
const originalSanitize = Link.sanitize

Link.sanitize = function (url: string) {
  if (url && !/^https?:\/\//i.test(url) && !/^mailto:/i.test(url)) {
    url = 'https://' + url
  }

  // Anropa Quill's ursprungliga sanitize-funktion
  return originalSanitize.call(this, url)
}
